module.exports = __webpack_public_path__ + "img/4a1e44e.jpg";